const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


export const saveRentalProfiling = async (data) => {
  try {
    const response = await fetch(`${API_BASE_URL}/rental-profiling`, {
      method: 'POST', // ✅ Specify POST method
      headers: {
        'Content-Type': 'application/json', 
         'Authorization': `Bearer ${localStorage.getItem('authToken')}`// ✅ Required for JSON payload
      },
      body: JSON.stringify(data), // ✅ Send data as JSON string
    });

    // Optionally check response status
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to save rental profiling data');
    }

    return await response.json(); // ✅ Parse response JSON
  } catch (error) {
    console.error('Error saving rental profiling data:', error);
    throw error;
  }
};
export const getRentalProfiling = async (connectionId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/rental-profiling/${connectionId}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
         'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const jsonData = await response.json();
    //console.log("Service returning data:", jsonData);
    
    return jsonData; // Return the parsed JSON directly
    
  } catch (error) {
    console.error("Error in getRentalProfiling:", error);
    throw error;
  }
};

// Update existing rental profile
export const updateRentalProfiling = async (id, data) => {
  try {
    const response = await fetch(`${API_BASE_URL}/rental-profiling/${id}`, {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
         'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
      body: JSON.stringify(data)
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const jsonData = await response.json();
    //console.log("Update response:", jsonData);
    
    return jsonData;
    
  } catch (error) {
    console.error("Error in updateRentalProfiling:", error);
    throw error;
  }
};
